<template>
    <div v-if="pdict.loyaltyForGuestEnabled && enableEarningPoints"
        :class="`form-group collapse  ${toggleDetailsObject.email.shown ? 'show' : ''}`" data-toggled-by="email">
        <input type="checkbox" id="fresh-rewards-terms-conditions" aria-label="fresh-rewards-terms-conditions"
            checked="checked" class="custom-checkbox form-check-input" value="true"
            v-bind="stringAttributesToObjects(lastFormData['shipping'].rewardsTermsConditions.attributes)" />

        <label for="fresh-rewards-terms-conditions" class="form-check-label">
            <!-- contentasset aid="CHECKOUT_loyaltyRewardsTermsConditions" -->
            <div class="content-asset" v-if="$t('content.asset.CHECKOUT_loyaltyRewardsTermsConditions')"
                v-html="$t('content.asset.CHECKOUT_loyaltyRewardsTermsConditions')"></div>
        </label>
    </div>
</template>

<script setup>
import { mapGetters } from "@/store/helper/vuex";
import { reactive } from 'vue'
import { EventBus as oldEventBus } from "@/scripts/event-bus.js";
import { stringAttributesToObjects } from "@/components/helper/util"


const { checkout, lastFormData } = mapGetters();

const pdict = checkout || mapGetters().pdict;

const toggleDetailsObject = reactive({
    email: {
        eventsActive: true,
        shown: false
    }
});

const enableEarningPoints = window.vue.customPreferences.showEarningPoints;

const toggleDetails = (detail) => {
    if (toggleDetailsObject[detail].eventsActive) {
        toggleDetailsObject[detail].shown = true
        toggleDetailsObject[detail].eventsActive = false
    }
}

oldEventBus.$off('shippingFormToggleEmailDetails');
oldEventBus.$on('shippingFormToggleEmailDetails', (detail) => {
    toggleDetails(detail)
});

</script>